import React, { useState } from 'react';

interface EmailProtectionProps {
  className?: string;
  style?: React.CSSProperties;
}

const EmailProtection: React.FC<EmailProtectionProps> = ({ className = "", style = {} }) => {
  const [showEmail, setShowEmail] = useState(false);
  
  // Email parts stored separately and obfuscated
  const emailParts = {
    user: 'luca',
    domain: 'iconic',
    tld: 'com',
    country: 'au'
  };
  
  const constructEmail = () => {
    return `${emailParts.user}@${emailParts.domain}.${emailParts.tld}.${emailParts.country}`;
  };
  
  const handleClick = () => {
    if (!showEmail) {
      setShowEmail(true);
      // Auto-hide after 30 seconds for additional security
      setTimeout(() => setShowEmail(false), 30000);
    } else {
      // If email is already shown, open mailto
      window.location.href = `mailto:${constructEmail()}`;
    }
  };
  
  return (
    <span 
      className={`email-protection ${className}`}
      style={{ cursor: 'pointer', textDecoration: 'underline', ...style }}
      onClick={handleClick}
      title={showEmail ? `Email: ${constructEmail()}` : "Click to reveal email address"}
    >
      {showEmail ? constructEmail() : "Click to reveal email"}
    </span>
  );
};

export default EmailProtection;